import React from 'react';
import { Helmet } from 'react-helmet-async';

const CleaningSpecial = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>$199 Dental Cleaning Special | New Patient Offer | Fort Worth Dental</title>
        <meta name="description" content="New patient dental cleaning special - only $199! Includes exam, X-rays, cleaning & oral cancer screening. Save over $150. Fort Worth Dental. Call (817) 985-3337." />
        <link rel="canonical" href="https://fortworthdental.com/specials/cleaning" />
      </Helmet>
      <section className="bg-gradient-to-br from-teal-600 to-teal-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">$199 Healthy Cleaning, Exam and set of X-Rays</h1>
          <p className="text-2xl">What is the secret for avoiding costly and painful dental work? The secret is preventative dental practices.</p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-teal-50 p-12 rounded-lg mb-12 text-center">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">New Patient Special</h2>
            <div className="text-6xl font-bold text-teal-600 mb-4">$199</div>
            <p className="text-2xl text-gray-700 mb-4">Complete Dental Package</p>
            <p className="text-gray-600">Regular Value: $350+</p>
          </div>

          <section className="mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">This Package Includes:</h3>
            <ul className="space-y-4 text-gray-700 text-lg">
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 text-2xl">✓</span>
                <span><strong>Professional Dental Cleaning</strong> - Remove plaque and tartar buildup</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 text-2xl">✓</span>
                <span><strong>Comprehensive Oral Examination</strong> - Thorough check of teeth, gums, and oral tissues</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 text-2xl">✓</span>
                <span><strong>Complete Set of X-Rays</strong> - Digital X-rays to detect hidden issues</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 text-2xl">✓</span>
                <span><strong>Oral Cancer Screening</strong> - Early detection can save lives</span>
              </li>
              <li className="flex items-start">
                <span className="text-teal-600 mr-3 text-2xl">✓</span>
                <span><strong>Treatment Plan</strong> - Personalized recommendations for optimal oral health</span>
              </li>
            </ul>
          </section>

          <section className="mb-12 bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Why Preventative Care Matters</h3>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              Regular dental cleanings and exams are the foundation of good oral health. By catching problems early, 
              you can avoid more expensive and invasive treatments down the road.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              Our comprehensive exam includes checking for cavities, oral cancer, and other conditions 
              that could affect your overall health.
            </p>
          </section>

          <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white p-12 rounded-lg text-center">
            <h3 className="text-3xl font-bold mb-4">Schedule Your $199 New Patient Special</h3>
            <p className="text-xl mb-8">Invest in your oral health today</p>
            <a href="tel:8179853337" className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 inline-block">
              Call (817) 985-3337
            </a>
            <p className="text-sm mt-4 opacity-90">*New patients only. Not valid with insurance. Some restrictions may apply.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CleaningSpecial;